import { Base } from './_base';
import { EntryPointFrontend } from '../frontend/entry-point';
import transform from 'lodash-es/transform';
import pick from 'lodash-es/pick';
import defaultsDeep from 'lodash-es/defaultsDeep';

export class EntryPointBackend extends Base {
  constructor(item) {
    super(item);
    this.type = 'start';
    this.number_id = item.number_id || null;
    this.caller_id = item.caller_id || null;
    this.action_id = item.data?.options?.next || null;
    this.hide_incoming_number = item.hide_incoming_number === true;
    this.record_type = item.record_type || 'no';
  }

  getData() {
    return pick(this, [
      'number_id',
      'caller_id',
      'hide_incoming_number',
      'record_type',
      'action_id',
      'data'
    ]);
  }

  toFrontend() {
    const new_transform = transform(super.toBaseFrontend(), function (result, value, key) {
      const params_keys = ['number_id', 'caller_id', 'hide_incoming_number', 'record_type'];
      const options_keys = ['action_id'];

      if ([...params_keys, ...options_keys].includes(key)) {
        const old_value = result['data'] || {};
        let new_value = {};

        if (params_keys.includes(key)) {
          new_value = { params: { [key]: value } };
        }

        if (options_keys.includes(key)) {
          new_value = { options: { next: value } };
        }

        result['data'] = defaultsDeep(new_value, old_value);
      } else {
        result[key] = value;
      }
    });

    return new EntryPointFrontend(new_transform);
  }
}
